import React from 'react';
import { Link, useLocation, Navigate, Outlet } from 'react-router-dom';

export default function AccountLayout() {
  const location = useLocation();
  const isBaseRoute = location.pathname === '/my-account';

  if (isBaseRoute) {
    return <Navigate to="/my-account/account-settings" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* 🔹 Sidebar Navigation */}
      <aside className="w-64 bg-white shadow-md p-6 space-y-4">
        <h2 className="text-xl font-bold text-indigo-700">My Account</h2>
        <nav className="flex flex-col space-y-2">
          <Link
            to="/my-account/account-settings"
            className="text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition"
          >
            Account Settings
          </Link>
          <Link
            to="/my-account/software"
            className="text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition"
          >
            Software
          </Link>
          <Link
            to="/my-account/billing"
            className="text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition"
          >
            Billing & Invoices
          </Link>
          <Link
            to="/my-account/subscription"
            className="text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition"
          >
            Subscription Plan
          </Link>
          <Link
            to="/my-account/team"
            className="text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition"
          >
            Team Members
          </Link>
          <Link
            to="/my-account/preferences"
            className="text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition"
          >
            Email Preferences
          </Link>
          <Link
            to="/my-account/audit"
            className="text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition"
          >
            Audit Logs
          </Link>
          <Link
            to="/my-account/support"
            className="text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition"
          >
            Support & Help
          </Link>

          {/* 🔙 Go to Main Site */}
          <Link
            to="/"
            className="mt-6 text-gray-700 hover:text-white hover:bg-indigo-600 px-4 py-2 rounded transition flex items-center"
          >
            <span className="mr-2">←</span> Go to Main Site
          </Link>
        </nav>
      </aside>

      {/* 🔹 Main Content */}
      <main className="flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
}
